import { getDefaultReasoningEffortForModel } from '@/lib/pieveComposerSettings.js';
import getModelReasoningLevels from '@/lib/model/getModelReasoningLevels.js';
import getAutomationItemThreadId from '@/redux/selectors/pieveSelectors/lib/getAutomationItemThreadId.js';

const getAutomationComposerReasoningEffort = ({ item, threadMetaByIdValue, modelId, fallbackThreadIdToItemId = false }) => {
  const automationThreadId = getAutomationItemThreadId({
    item,
    fallbackToId: fallbackThreadIdToItemId
  });
  const effort = String(item?.composerReasoningEffort || '').trim() || String(threadMetaByIdValue?.[automationThreadId]?.composerReasoningEffort || '').trim() || null;
  return (getModelReasoningLevels(modelId).includes(effort) ? effort : null) || getDefaultReasoningEffortForModel(modelId);
};

export default getAutomationComposerReasoningEffort;
